import { useUserSignatures } from "@cs_teamwaydev/mailvista-sdk_react";
import { useMutation, UseMutationResult } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import useErrorToast from "../utils/useErrorToast";
import { useToast } from "../utils/useToast";

const useDeleteUserSignature = (): {
    deleteUserSignature: UseMutationResult<void, Error, string>;
} => {
    const userSignatures = useUserSignatures();
    const showErrorToast = useErrorToast();
    const { toast } = useToast();
    const { t } = useTranslation();

    const deleteUserSignatureFn = async (id: string): Promise<void> => {
        try {
            await userSignatures.deleteUserSignature(id);

            toast({
                description: t("settings.signature.form.deleteSuccess"),
                variant: "success",
            });
        } catch (error) {
            console.error(error);
            showErrorToast({
                titleTranslationKey: "errors.signature.delete",
            });
        }
    };

    const deleteUserSignature = useMutation({
        mutationFn: (id: string) => deleteUserSignatureFn(id),
    });

    return {
        deleteUserSignature,
    };
};

export default useDeleteUserSignature;
